const GAME_RESULT_KEY = "__gameResult";
const KIT_LOTS = ["kit-apero", "kit-salade"];

const normalizeStatus = (status) => (status || "").toString().toUpperCase();
const normalizeLot = (lot) => (lot || "").toString().toLowerCase();
const normalizeFlow = (flow) => (flow || "").toString().toLowerCase();

const normalizeGameResult = (result) => {
  if (!result) return null;

  const normalized = {
    status: normalizeStatus(result.status),
    lot: normalizeLot(result.lot),
    flow: normalizeFlow(result.flow),
  };

  if (!normalized.status) {
    return null;
  }

  return normalized;
};

export const setGameResult = (result, flow = "") => {
  const normalized = normalizeGameResult({
    status: result?.status,
    lot: result?.lot,
    flow,
  });

  if (typeof window === "undefined" || !normalized) {
    return normalized;
  }

  window.__gameResult = normalized;

  try {
    sessionStorage.setItem(GAME_RESULT_KEY, JSON.stringify(normalized));
  } catch (error) {
    console.warn("Unable to persist game result", error);
  }

  return normalized;
};

export const getGameResult = () => {
  if (typeof window === "undefined") {
    return null;
  }

  const fromWindow = normalizeGameResult(window.__gameResult);
  if (fromWindow) {
    return fromWindow;
  }

  try {
    const fromStorage = sessionStorage.getItem(GAME_RESULT_KEY);
    if (!fromStorage) {
      return null;
    }

    const parsed = normalizeGameResult(JSON.parse(fromStorage));
    if (parsed) {
      window.__gameResult = parsed;
    }
    return parsed;
  } catch (error) {
    console.warn("Unable to read persisted game result", error);
    return null;
  }
};

export const clearGameResult = () => {
  if (typeof window === "undefined") {
    return;
  }

  try {
    delete window.__gameResult;
    sessionStorage.removeItem(GAME_RESULT_KEY);
  } catch (error) {
    console.warn("Unable to clear persisted game result", error);
  }
};

export const isWinningVoyageResult = (result) => {
  const normalized = normalizeGameResult(result);
  return (
    !!normalized &&
    normalized.status === "GAGNE" &&
    normalized.lot === "voyage" &&
    normalized.flow === "form"
  );
};

export const isWinningKitResult = (result) => {
  const normalized = normalizeGameResult(result);
  return (
    !!normalized &&
    normalized.status === "GAGNE" &&
    KIT_LOTS.includes(normalized.lot) &&
    normalized.flow === "formig"
  );
};

export const isCodePerdantResult = (result) => {
  const normalized = normalizeGameResult(result);
  return (
    !!normalized &&
    normalized.status === "PERD" &&
    normalized.flow === "form"
  );
};

export const isPerduResult = (result) => {
  const normalized = normalizeGameResult(result);
  return (
    !!normalized &&
    normalized.status === "PERD" &&
    normalized.flow === "formig"
  );
};
